import authService from '../authService';

// This mixin module makes it really easy to instantly access the auth module from anywhere in our Vue app
export default {
	install(Vue) {
		Vue.prototype.$auth = authService;

		// By default, all mixins are available in every Vue component
		Vue.mixin({
			created() {
				// Upon component creation, if that component indicates it cares about login events, we'll let them know!
				if (this.handleLoginEvent) {
					authService.addListener('loginEvent', this.handleLoginEvent);
				}
			},

			destroyed() {
				// Dotting our i's and crossing our t's - we better make sure to unregister listeners when components die
				if (this.handleLoginEvent) {
					authService.removeListener('loginEvent', this.handleLoginEvent);
				}
			}
		});
	}
};
